/* eslint prettier/prettier: "off" */
/* eslint no-use-before-define: "off" */
/* eslint quotes: "off" */
/* eslint unicorn/prefer-code-point: "off" */

/**
 * DO NOT EDIT!!
 *
 * This is a copy and paste of a fully tested util file called from banking-web repo.
 * We are copying because we want the code to be the same for both dashboard and banking-web
 * when working with bb-debit Card.
 *
 * https://github.com/squareup/banking-web/blob/main/src/util/card-v2.ts
 */

import { ExpiryDateFormatter } from 'field-kit';
import { CardStatus, Customization } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';

/**
 * Utilities to help parse Card
 */
export const getBusinessName = card => {
  const customizationArr = card.fulfillment?.customization;
  if (customizationArr && customizationArr.length > 0) {
    return customizationArr[0].cardTexts.find(cardText => cardText.type === Customization.CardText.Type.CARD_TEXT_TYPE_BUSINESS_NAME)?.text || "";
  }
  return "";
};
export const getCardholder = card => {
  const customizationArr = card.fulfillment?.customization || [];
  if (customizationArr.length > 0) {
    return customizationArr[0].cardTexts.find(cardText => cardText.type === Customization.CardText.Type.CARD_TEXT_TYPE_CARDHOLDER_NAME)?.text || "";
  }
  return "";
};
export const getCvc = card => {
  return card.securityCode || "";
};
export const getExpirationDateString = card => {
  const formatter = new ExpiryDateFormatter();
  return card.expiration ? formatter.format({
    month: card.expiration.monthOfYear,
    year: card.expiration.year
  }) : "";
};
export const getFullPan = card => {
  return card.fullPan || "";
};
export const isActivatable = card => card?.status === CardStatus.CARD_STATUS_ACTIVATABLE;